import { useHealthblocksSWR, useSubjectId } from '@healthblocks-io/core'

import type { CommunicationDocument } from '../types/documents.types'

export function useCommunicationDocument(fileId?: string) {
  const subjectId = useSubjectId()

  return useHealthblocksSWR<CommunicationDocument>(
    fileId && subjectId ? `/synops/communication-document/${fileId}?subjectId=${subjectId}` : null,
  )
}

export function useSynopsDocument(fileId?: string) {
  const subjectId = useSubjectId()

  return useHealthblocksSWR<CommunicationDocument>(
    fileId && subjectId ? `/synops/document/${fileId}?subjectId=${subjectId}` : null,
  )
}
